import { Stack } from '@mui/material';

import { styled } from '@/theme/styled';
import { getBorder } from '@/theme/utils';

const Section = styled(Stack)(({ theme }) => ({
  padding: theme.spacing(2),
  borderBottom: getBorder(theme.palette.border.default),
}));

export { Section };
